module.exports = "<drag-scroll #scroll [scrollbar-hidden]=\"true\" [drag-scroll-y-disabled]=\"true\" style=\"width: auto; height: auto;\"\r\n(mousedown)=\"pauseAnimation()\" (mouseup)=\"restartAnimation()\">\r\n    <div class=\"stats-container\"\r\n    [ngStyle]=\"{'height': height}\">\r\n        <ng-content></ng-content>\r\n    </div>\r\n</drag-scroll>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/stats/stats.component.html
// module id = ./src/app/components/stats/stats.component.html
// module chunks = main